const permission = {
    name: "Permission",
    items: {
        KPI_DASHBOARD_READ: {
            value: 1,
            text: "KPI Dashboard - Read",
            name: "KPI_DASHBOARD_READ"
        },
        FERTILITY_DASHBOARD_READ: {
            value: 2,
            text: "Fertility Dashboard - Read",
            name: "FERTILITY_DASHBOARD_READ"
        },
        TM_DASHBOARD_READ: {
            value: 3,
            text: "TM Dashboard - Read",
            name: "TM_DASHBOARD_READ"
        },
        BENCHMARKING_READ: {
            value: 5,
            text: "Benchmarking - Read",
            name: "BENCHMARKING_READ"
        },
        FARM_ADMIN_UPDATE: {
            value: 10,
            text: "Farm Admin - Update",
            name: "FARM_ADMIN_UPDATE"
        },
        FARM_ADMIN_READ: {
            value: 11,
            text: "Farm Admin - Read",
            name: "FARM_ADMIN_READ"
        },
        USER_MANAGEMENT_UPDATE: {
            value: 14,
            text: "User Management - Update",
            name: "USER_MANAGEMENT_UPDATE"
        },
        USER_MANAGEMENT_READ: {
            value: 15,
            text: "User Management - Read",
            name: "USER_MANAGEMENT_READ"
        },
        HERD_DATA_UPDATE: {
            value: 16,
            text: "Herd Data - Update",
            name: "HERD_DATA_UPDATE"
        },
        HERD_DATA_READ: {
            value: 17,
            text: "Herd Data - Read",
            name: "HERD_DATA_READ"
        },
        BREEDING_CODES_READ: {
            value: 18,
            text: "Breeding Codes - Read",
            name: "BREEDING_CODES_READ"
        },
        USER_PROFILE_READ: {
            value: 20,
            text: "User Profile - Read",
            name: "USER_PROFILE_READ"
        },
        FEEDBACK: {
            value: 21,
            text: "Feedback",
            name: "FEEDBACK"
        },
        FARM_DEMOGRAPHICS_UPDATE: {
            value: 22,
            text: "Farm Demographics - Update",
            name: "FARM_DEMOGRAPHICS_UPDATE"
        },
        FARM_DEMOGRAPHICS_READ: {
            value: 23,
            text: "Farm Demographics - Read",
            name: "FARM_DEMOGRAPHICS_READ"
        },
        COMMON_SETTINGS_UPDATE: {
            value: 24,
            text: "Common Settings - Update",
            name: "COMMON_SETTINGS_UPDATE"
        },
        COMMON_SETTINGS_READ: {
            value: 25,
            text: "Common Settings - Read",
            name: "COMMON_SETTINGS_READ"
        },
        LACTATION_1_UPDATE: {
            value: 26,
            text: "Lactation 1 - Update",
            name: "LACTATION_1_UPDATE"
        },
        LACTATION_1_READ: {
            value: 27,
            text: "Lactation 1 - Read",
            name: "LACTATION_1_READ"
        },
        LACTATION_2_UPDATE: {
            value: 28,
            text: "Lactation 2 - Update",
            name: "LACTATION_2_UPDATE"
        },
        LACTATION_2_READ: {
            value: 29,
            text: "Lactation 2 - Read",
            name: "LACTATION_2_READ"
        },
        TECHNICIAN_DASHBOARD_READ: {
            value: 30,
            text: "Technician Dashboard - Read",
            name: "TECHNICIAN_DASHBOARD_READ"
        },
        SIRE_DASHBOARD_READ: {
            value: 31,
            text: "Sire Dashboard - Read",
            name: "SIRE_DASHBOARD_READ"
        },
        ADMIN_FARM_MANAGEMENT_UPDATE: {
            value: 32,
            text: "Admin Farm Managment - Update",
            name: "ADMIN_FARM_MANAGEMENT_UPDATE"
        },
        ADMIN_FARM_MANAGEMENT_READ: {
            value: 33,
            text: "Admin Farm Managment - Read",
            name: "ADMIN_FARM_MANAGEMENT_READ"
        },
        ADMIN_USER_MANAGEMENT_UPDATE: {
            value: 34,
            text: "Admin User Managment - Update",
            name: "ADMIN_USER_MANAGEMENT_UPDATE"
        },
        ADMIN_USER_MANAGEMENT_READ: {
            value: 35,
            text: "Admin User Managment - Read",
            name: "ADMIN_USER_MANAGEMENT_READ"
        },
        TM_DASHBOARD_UPDATE: {
            value: 36,
            text: "TM Dashboard - Update",
            name: "TM_DASHBOARD_UPDATE"
        },
        FARM_MANAGEMENT_MAINT_UPDATE: {
            value: 37,
            text: "Farm Management Maint - Update",
            name: "FARM_MANAGEMENT_MAINT_UPDATE"
        },
        FARM_MANAGEMENT_MAINT_READ: {
            value: 38,
            text: "Farm Management Maint - Read",
            name: "FARM_MANAGEMENT_MAINT_READ"
        },
        ADMIN_USER_MANAGEMENT_MAINT_UPDATE: {
            value: 39,
            text: "Admin User Management Maint - Update",
            name: "ADMIN_USER_MANAGEMENT_MAINT_UPDATE"
        },
        ADMIN_USER_MANAGEMENT_MAINT_READ: {
            value: 40,
            text: "Admin User Management Maint - Read",
            name: "ADMIN_USER_MANAGEMENT_MAINT_READ"
        },
        MULTIFARM_DASHBOARD_UPDATE: {
            value: 41,
            text: "Multifarm Dashboard - Update",
            name: "MULTIFARM_DASHBOARD_UPDATE"
        },
        MULTIFARM_DASHBOARD_READ: {
            value: 42,
            text: "Multifarm Dashboard - Read",
            name: "MULTIFARM_DASHBOARD_READ"
        },
        BENCHMARKING_UPDATE: {
            value: 43,
            text: "Benchmarking - Update",
            name: "BENCHMARKING_UPDATE"
        },
        KPI_DASHBOARD_UPDATE: {
            value: 44,
            text: "KPI Dashboard - Update",
            name: "KPI_DASHBOARD_UPDATE"
        },
        MY_FARM_RANKS_UPDATE: {
            value: 45,
            text: "My Farm Ranks - Update",
            name: "MY_FARM_RANKS_UPDATE"
        },
        MY_FARM_RANKS_READ: {
            value: 46,
            text: "My Farm Ranks - Read",
            name: "MY_FARM_RANKS_READ"
        },
        TECHNICIAN_DASHBOARD_UPDATE: {
            value: 47,
            text: "Technician Dashboard - Update",
            name: "TECHNICIAN_DASHBOARD_UPDATE"
        },
        SIRE_DASHBOARD_UPDATE: {
            value: 48,
            text: "Sire Dashboard - Update",
            name: "SIRE_DASHBOARD_UPDATE"
        },
        FERTILITY_DASHBOARD_UPDATE: {
            value: 49,
            text: "Fertility Dashboard - Update",
            name: "FERTILITY_DASHBOARD_UPDATE"
        },
        CONCEPTION_DASHBOARD_UPDATE: {
            value: 50,
            text: "Conception Dashboard - Update",
            name: "CONCEPTION_DASHBOARD_UPDATE"
        },
        CONCEPTION_DASHBOARD_READ: {
            value: 51,
            text: "Conception Dashboard - Read",
            name: "CONCEPTION_DASHBOARD_READ"
        },
        THREE_YEAR_TRENDS_UPDATE: {
            value: 52,
            text: "3-Year Trends - Update",
            name: "THREE_YEAR_TRENDS_UPDATE"
        },
        THREE_YEAR_TRENDS_READ: {
            value: 53,
            text: "3-Year Trends - Read",
            name: "THREE_YEAR_TRENDS_READ"
        },
        SEASONAL_TRENDS_UPDATE: {
            value: 54,
            text: "Seasonal Trends - Update",
            name: "SEASONAL_TRENDS_UPDATE"
        },
        SEASONAL_TRENDS_READ: {
            value: 55,
            text: "Seasonal Trends - Read",
            name: "SEASONAL_TRENDS_READ"
        },
        FERTILITY_ANALYSIS_UPDATE: {
            value: 56,
            text: "Fertility Analysis - Update",
            name: "FERTILITY_ANALYSIS_UPDATE"
        },
        FERTILITY_ANALYSIS_READ: {
            value: 57,
            text: "Fertility Analysis - Read",
            name: "FERTILITY_ANALYSIS_READ"
        },
        FARM_GOAL_MANAGEMENT_UPDATE: {
            value: 58,
            text: "Farm Goal Management - Update",
            name: "FARM_GOAL_MANAGEMENT_UPDATE"
        },
        FARM_GOAL_MANAGEMENT_READ: {
            value: 59,
            text: "Farm Goal Management - Read",
            name: "FARM_GOAL_MANAGEMENT_READ"
        },
        F360_DASHBOARD_PUBLISHED_REPORTS_UPDATE: {
            value: 60,
            text: "F360 Dasbhoard & Published Reports - Update",
            name: "F360_DASHBOARD_PUBLISHED_REPORTS_UPDATE"
        },
        F360_DASHBOARD_PUBLISHED_REPORTS_READ: {
            value: 61,
            text: "F360 Dasbhoard & Published Reports - Read",
            name: "F360_DASHBOARD_PUBLISHED_REPORTS_READ"
        },
        F360_EVALUATION_TOOL_UPDATE: {
            value: 62,
            text: "F360 Evaluation Tool - Update",
            name: "F360_EVALUATION_TOOL_UPDATE"
        },
        F360_EVALUATION_TOOL_READ: {
            value: 63,
            text: "F360 Evaluation Tool - Read",
            name: "F360_EVALUATION_TOOL_READ"
        },
        JOURNAL_UPDATE: {
            value: 64,
            text: "Journal - Update",
            name: "JOURNAL_UPDATE"
        },
        JOURNAL_READ: {
            value: 65,
            text: "Journal - Read",
            name: "JOURNAL_READ"
        },
        BREEDING_CODES_UPDATE: {
            value: 66,
            text: "Breeding Codes - Update",
            name: "BREEDING_CODES_UPDATE"
        },
        EMM_RETRIEVE_SHOT_LIST_UPDATE: {
            value: 67,
            text: "eMM Retrieve Shot List - Update",
            name: "EMM_RETRIEVE_SHOT_LIST_UPDATE"
        },
        EMM_RETRIEVE_SHOT_LIST_READ: {
            value: 68,
            text: "eMM Retrieve Shot List - Read",
            name: "EMM_RETRIEVE_SHOT_LIST_READ"
        },
        FIELD_REPORTS_UPDATE: {
            value: 69,
            text: "eMM Field Reports - Update",
            name: "FIELD_REPORTS_UPDATE"
        },
        FIELD_REPORTS_READ: {
            value: 70,
            text: "eMM Field Reports - Read",
            name: "FIELD_REPORTS_READ"
        },
        USER_PROFILE_UPDATE: {
            value: 71,
            text: "User Profile - Update",
            name: "USER_PROFILE_UPDATE"
        }
    }
}
export const Permission = permission;